<div *ngIf="loading">
  <div [ngClass]="{'global-loader': true, 'global-loader-dark': sharedService.darkMode}">
    <h1>Loading</h1>
  </div>
</div>

<div fxLayout="column" *ngIf="!loading">
  <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="100" class="matero-col" fxLayoutAlign="start">
      <h2 class="noMarginHeader">
        <mat-icon>pending_actions</mat-icon> Pending Access Updates
      </h2>
    </div>
  </div>

  <mat-card>
    <mat-card-content>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" style="margin-bottom: 16px;">
        <strong class="noMarginHeader">Results ({{pendingAccessUpdatesDataSource?.filteredData?.length || 0}})</strong>
        <mat-form-field appearance="outline" style="width: 300px;">
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Search..." #input>
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>

      <mat-table [dataSource]="pendingAccessUpdatesDataSource" matSort #PendingAccessTableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
        <mat-header-row fxLayout="row" fxLayout.lt-md="column" *matHeaderRowDef="pendingAccessTable.layout.columns"></mat-header-row>
        <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: pendingAccessTable.layout.columns" title="Pending Access Update"></mat-row>

        <ng-container matColumnDef="atpId">
          <mat-header-cell mat-sort-header fxFlex="10" *matHeaderCellDef>ATP Id</mat-header-cell>
          <mat-cell *matCellDef="let row" fxFlex="10">
            <a *ngIf="row.atpId" class="blue-text" (click)="openAtp(row.atpId)" style="cursor: pointer;">
              {{row.atpId}}
            </a>
            <span *ngIf="!row.atpId">-</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="firmId">
          <mat-header-cell mat-sort-header fxFlex="10" *matHeaderCellDef>Firm Id</mat-header-cell>
          <mat-cell *matCellDef="let row" fxFlex="10">
            <a *ngIf="row.firmId" class="blue-text" (click)="openFirm(row.firmId)" style="cursor: pointer;">
              {{row.firmId}}
            </a>
            <span *ngIf="!row.firmId">-</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="personId">
          <mat-header-cell mat-sort-header fxFlex="10" *matHeaderCellDef>Individual Id</mat-header-cell>
          <mat-cell *matCellDef="let row" fxFlex="10">
            <a *ngIf="row.personId" class="blue-text" (click)="openPerson(row.personId)" style="cursor: pointer;">
              {{row.personId}}
            </a>
            <span *ngIf="!row.personId">-</span>
          </mat-cell>
        </ng-container>

        <ng-container *ngFor="let cellData of pendingAccessTable.layout.container; let i = index" [matColumnDef]="cellData.columnName">
          <mat-header-cell mat-sort-header [fxFlex]="cellData.size" *matHeaderCellDef>{{ cellData.displayName }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" matTooltip="{{row[cellData.columnName]}}">
            <ng-container [ngSwitch]="cellData.type">
              <ng-container *ngSwitchCase="'date'">
                {{ row[cellData.columnName] | date: 'MM/dd/yyyy' }}
              </ng-container>
              <ng-container *ngSwitchCase="'bool'">
                <mat-checkbox [checked]="row[cellData.columnName]" disabled></mat-checkbox>
              </ng-container>
              <ng-container *ngSwitchCase="'link'">
                <!-- Handled separately above -->
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{ displayLimit(row[cellData.columnName], cellData.size) }}
              </ng-container>
            </ng-container>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef fxFlex="7">Actions</mat-header-cell>
          <mat-cell *matCellDef="let row" fxFlex="7">
            <div style="display: flex; justify-content: space-between; width: 100px;">
              <button mat-icon-button [color]="row.status === 'Active' ? 'primary' : 'warn'" style="width: 50px;" 
                (click)="toggleStatus(row); $event.stopPropagation()" 
                [title]="row.status === 'Active' ? 'Deactivate' : 'Activate'">
                <mat-icon>{{row.status === 'Active' ? 'toggle_on' : 'toggle_off'}}</mat-icon>
              </button>
            </div>
          </mat-cell>
        </ng-container>
      </mat-table>

      <mat-paginator [pageSize]="pendingAccessTablePageSize" [pageSizeOptions]="[5, 10, 25, 50]" 
        #PendingAccessTablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
